import type { ComponentProps } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { styled } from '@components-shared/src/stitches';
import { GlobalDropdown } from '@components/basics/Dropdowns/GlobalDropdown';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

export const MoreDropdown = ({
  align = 'center',
  children,
  triggerProps,
  dropdownProps,
  disabled,
}: {
  align?: 'start' | 'center' | 'end';
  children: React.ReactNode;
  triggerProps?: Partial<ComponentProps<typeof MoreDropdownTrigger>>;
  dropdownProps?: Partial<React.ComponentProps<typeof GlobalDropdown>>;
  disabled?: boolean;
}) => {
  return (
    <GlobalDropdown
      trigger={
        <MoreDropdownTrigger
          disabled={disabled}
          onClick={e => e.stopPropagation()}
          icon={<FontAwesomeIcon icon={faEllipsis} size="lg" />}
          {...triggerProps}
        />
      }
      align={align}
      {...dropdownProps}
    >
      {children}
    </GlobalDropdown>
  );
};

const MoreDropdownTrigger = styled(IconButton, {
  variants: {
    endTable: {
      true: {
        marginLeft: '15px',
      },
    },
  },
});
